'use strict';

import Address from 'common/models/Address';

class Order {
    constructor() {
        _.extend(this, {
            id: new Date().getTime(),
            order_items_attributes: null,
            from_address_attributes: new Address(),
            to_address_attributes: new Address()
        });
    }
}

export default Order;



// WEBPACK FOOTER //
// ./client/app/common/models/Order.js